import { h } from '@stencil/core';
import { productCtas, CAASContentOverviewSlotName, tryParse } from '@pes-ui/utils';
import { requestRangeSelectorConfig } from '../product-range/helper';
import { updateProductCtasSelectorSettings, } from '../UI/product-selector/product-selector-utils';
import { TAB_NAMES } from '../pes-app-range/constants';
import { getFilteredBreadcrumbs } from '../breadcrumbs/utils';
import { PBS_BACKGROUND_COLOR } from './constants';
import { PesRouterStore } from '../../index';
const propsToParse = [
  { prop: '_showBreadcrumbs', target: 'showBreadcrumbs' },
  { prop: '_mainInfo', target: 'mainInfo' },
  { prop: '_isPBS', target: 'isPBS' },
  { prop: '_rangeId', target: 'rangeId' },
  { prop: '_countryCode', target: 'countryCode' },
  { prop: '_languageCode', target: 'languageCode' },
  { prop: '_showDocuments', target: 'showDocuments' },
  { prop: '_tabs', target: 'tabs' },
  { prop: '_metaTags', target: 'metaTags' },
  { prop: '_showBuyOnline', target: 'showBuyOnline' },
];
export class ProductAppRange {
  constructor() {
    this.productCtasState = this.productCtas;
    this.productSelector = null;
    this.SE_BRAND = 'se';
    this.requestRangeSelectorConfigCreator = () => requestRangeSelectorConfig(this.host, this.rangeId, {
      countryCode: this.countryCode,
      languageCode: this.languageCode,
      brand: this.SE_BRAND,
    });
    this._showBreadcrumbs = undefined;
    this._mainInfo = undefined;
    this._tabs = undefined;
    this._metaTags = undefined;
    this._rangeId = undefined;
    this._countryCode = undefined;
    this._languageCode = undefined;
    this._isPBS = undefined;
    this._showBuyOnline = undefined;
    this._showDocuments = undefined;
    this.isPBS = true;
    this.host = undefined;
    this.endpoint = undefined;
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.rangeId = undefined;
    this.showBreadcrumbs = undefined;
    this.showDocuments = undefined;
    this.productCtas = productCtas;
    this.showBuyOnline = undefined;
    this.siteType = undefined;
    this.mainInfo = undefined;
    this.tabs = undefined;
    this.metaTags = undefined;
    this.isTabsInitialized = false;
    this.isLoading = false;
    this.documentsTabEnabled = {
      [TAB_NAMES.Documents]: false,
      [TAB_NAMES.Software]: false,
    };
    this.documentListing = undefined;
    this.hostWithLocale = '';
  }
  productCtasDidChange(newProductCtas) {
    this.selectorExtraOptions = updateProductCtasSelectorSettings(this.productSelector, this.productCtas.buttons);
    this.productCtasState = Object.assign({}, newProductCtas);
  }
  get customBreadcrumbs() {
    var _a;
    if (!this.showBreadcrumbs) {
      return null;
    }
    return getFilteredBreadcrumbs((_a = this.mainInfo) === null || _a === void 0 ? void 0 : _a.breadcrumbs, this.isPBS ? undefined : []);
  }
  getRichText(content) {
    const { richText } = content;
    const richTextResponse = richText || content.MainContent[0].richText;
    return richTextResponse === null || richTextResponse === void 0 ? void 0 : richTextResponse.map((item) => item.replace(/<p>|&nbsp;|&#160;|<\/p>/g, '').trim());
  }
  componentWillLoad() {
    propsToParse.forEach(({ prop, target }) => {
      var _a;
      this[target] = ((_a = tryParse(this[prop])) !== null && _a !== void 0 ? _a : this[target]);
    });
    if (this.isPBS)
      PesRouterStore.set('enableAppRouting', true);
    this.hostWithLocale = `${this.host}${this.countryCode}/${this.languageCode}/`;
  }
  render() {
    const { image, name, description, masterRangeName, longDescription, rangePartofLabel, } = this.mainInfo;
    const { analyticsPageData } = this.metaTags;
    return (h("se-container", { display: "block", style: {
        'background-color': PBS_BACKGROUND_COLOR,
      } }, this.showBreadcrumbs && (h("pes-breadcrumbs", { breadcrumbs: this.customBreadcrumbs, hideOnMobile: false, class: "pes-app-pdp__section pes-app-pdp__section--breadcrumbs", hostWithLocale: this.hostWithLocale })), h("pes-range-main", { host: this.host, endpoint: this.endpoint, rangePartofLabel: rangePartofLabel, commercialStatus: this.mainInfo.commercialStatus, description: description, image: image, longDescription: longDescription, masterRangeName: masterRangeName, name: name, brandLogo: this.mainInfo.brandLogo, id: this.mainInfo.id, localeCode: `${this.countryCode.toUpperCase()}/${this.languageCode}`, rangeCtas: this.mainInfo.rangeCtas, requestRangeSelectorConfig: this.requestRangeSelectorConfigCreator, readMoreLabel: this.mainInfo.readMoreLabel, readLessLabel: this.mainInfo.readLessLabel, learnMoreLabel: this.mainInfo.learnMoreLabel, moreOptionsLabel: this.mainInfo.moreOptionsLabel, rangeType: this.mainInfo.rangeType }), this.tabs.tabs && (h("pes-spryker-range-tabs", { tabs: this.tabs.tabs, hostWithLocale: this.hostWithLocale, appProductsLabel: this.mainInfo.appProductsLabel, commonFiltersFilterBy: this.mainInfo.commonFiltersFilterBy, facetButtonResetAllLabel: this.mainInfo.facetButtonResetAllLabel, facetButtonViewLessFilters: this.mainInfo.facetButtonViewLessFilters, facetButtonViewMoreFilters: this.mainInfo.facetButtonViewMoreFilters, nextLabel: this.mainInfo.nextLabel, pageLabel: this.tabs.pageLabel, noResultsClearLink: this.mainInfo.noResultsClearLink, noResultsHeader: this.mainInfo.noResultsHeader, noResultsMessage: this.mainInfo.noResultsMessage, numberProductsOfAllProductsLabel: this.mainInfo.numberProductsOfAllProductsLabel, previousLabel: this.mainInfo.previousLabel, rangeProductLabel: this.mainInfo.rangeProductLabel, rangeProductsFiltersLabel: this.mainInfo.rangeProductsFiltersLabel, viewLessLabel: this.mainInfo.viewLessLabel, viewMoreLabel: this.mainInfo.viewMoreLabel, viewProductsLabel: this.mainInfo.viewProductsLabel, rangePresentationLabel: this.mainInfo.rangePresentationLabel, loadMoreLabel: this.tabs.loadMoreLabel, loadPreviousLabel: this.tabs.loadPreviousLabel, backLabel: this.mainInfo.backLabel, localeCode: `/${this.countryCode}/${this.languageCode}`, rangeReference: this.mainInfo.rangeReference, host: this.host, endpoint: this.endpoint, rangeSoftwareAndFirmwareLabel: this.tabs.rangeSoftwareAndFirmwareLabel, rangeWebinarsAndResourcesLabel: this.tabs.rangeWebinarsAndResourcesLabel, softwareRegistrationLabel: this.tabs.softwareRegistrationLabel, descriptionBigger: this.mainInfo.descriptionBigger, id: this.mainInfo.id, name: name, navigationState: this.mainInfo.navigationState, showDocuments: this.showDocuments, showBuyOnline: this.showBuyOnline, productCtas: this.productCtasState, isPBS: this.isPBS, documentListing: this.documentListing, analyticsPageData: analyticsPageData, rangeBanner: this.tabs.rangeBanner }, h("slot", { slot: CAASContentOverviewSlotName, name: CAASContentOverviewSlotName })))));
  }
  static get is() { return "pes-app-spryker-range"; }
  static get encapsulation() { return "shadow"; }
  static get properties() {
    return {
      "_showBreadcrumbs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-breadcrumbs",
        "reflect": false
      },
      "_mainInfo": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-main-info",
        "reflect": false
      },
      "_tabs": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-tabs",
        "reflect": false
      },
      "_metaTags": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-meta-tags",
        "reflect": false
      },
      "_rangeId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-range-id",
        "reflect": false
      },
      "_countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-country-code",
        "reflect": false
      },
      "_languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-language-code",
        "reflect": false
      },
      "_isPBS": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-pbs",
        "reflect": false
      },
      "_showBuyOnline": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-buy-online",
        "reflect": false
      },
      "_showDocuments": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-documents",
        "reflect": false
      },
      "isPBS": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-p-b-s",
        "reflect": false,
        "defaultValue": "true"
      },
      "host": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "host",
        "reflect": false
      },
      "endpoint": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "endpoint",
        "reflect": false
      },
      "countryCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "country-code",
        "reflect": false
      },
      "languageCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "language-code",
        "reflect": false
      },
      "rangeId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "range-id",
        "reflect": false
      },
      "showBreadcrumbs": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Callback function for Breadcrumbs"
        },
        "attribute": "show-breadcrumbs",
        "reflect": false
      },
      "showDocuments": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "If show Documents CTA and documents list in product-card"
        },
        "attribute": "show-documents",
        "reflect": false
      },
      "productCtas": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TProductCtas",
          "resolved": "{ buttons: TProductCtasButtons; productProp?: string; }",
          "references": {
            "TProductCtas": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Setup productCtas logic.\nbuttons - predefined CTA buttons.\nproductProp - predefined property of product to find in list."
        },
        "defaultValue": "productCtas"
      },
      "showBuyOnline": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Show buy online button"
        },
        "attribute": "show-buy-online",
        "reflect": false
      },
      "siteType": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "TSiteType",
          "resolved": "\"b2b\" | \"b2c\"",
          "references": {
            "TSiteType": {
              "location": "import",
              "path": "../../globals/types"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "Defines the context of the app: B2B or B2C"
        },
        "attribute": "site-type",
        "reflect": false
      },
      "mainInfo": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "RangeMainInfo",
          "resolved": "{ appProductsLabel?: string; brandLogo?: Logo; breadcrumbs?: TBreadcrumbs[]; backLabel?: string; commonFiltersFilterBy?: string; configureProductLabel?: string; commercialStatus?: CommercialStatus; description?: string; descriptionBigger?: boolean; facetButtonResetAllLabel?: string; giftlistAddToGiftlistLabel?: string; id?: string; image?: ImageLink; longDescription?: string; masterRangeDescription?: string; masterRangeName?: string; name?: string; navigationState?: string; nodes?: Nodes[]; noResultsClearLink?: string; noResultsHeader?: string; noResultsMessage?: string; numberProductsOfAllProductsLabel?: string; numberProductsOnRangePage: string; productEndofcommercializationLabel?: string; productPrimarylegaltextLabel?: string; productSecondarylegaltextLabel?: string; rangeIntroProductConfiguratorLabel?: string; rangePartofLabel?: string; rangePresentationLabel?: string; rangeProductLabel?: string; rangeProductListShowLabel?: string; rangeProductsFiltersLabel?: string; rangeProductsViewDetailsLabel?: string; rangeReference?: string; removeFromMyFavoritesLabel?: string; status?: string; substitutionLabelRecommendedReplacement?: string; facetButtonViewMoreFilters?: string; facetButtonViewLessFilters?: string; previousLabel?: string; nextLabel?: string; viewProductsLabel?: string; productsLabel?: string; rangeDocuments: string; rangeSoftwareAndFirmwareLabel: string; viewMoreLabel: string; viewLessLabel: string; rangeCtas: TRangeCTAs; labelValue: string; loadMoreButton: string; loadPreviousButton: string; currentReference: string; loadMoreLabel?: string; loadPreviousLabel?: string; pageLabel?: string; softwareRegistrationLabel?: string; rangeWebinarsAndResourcesLabel?: string; localeCode: string; readMoreLabel: string; readLessLabel: string; learnMoreLabel: string; moreOptionsLabel: string; rangeType?: string; rangeBanner?: MarketingBannerData; }",
          "references": {
            "RangeMainInfo": {
              "location": "import",
              "path": "../product-range/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "tabs": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "RangeTabs",
          "resolved": "{ tabs: TRangeTabs; } & RangeMainInfo",
          "references": {
            "RangeTabs": {
              "location": "import",
              "path": "../product-range/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "metaTags": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "MetaTags",
          "resolved": "MetaTags",
          "references": {
            "MetaTags": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        }
      },
      "documentListing": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "Partial<DDCProps>",
          "resolved": "{ documentLabel?: string; softwareAndFirmwareLabel?: string; productId?: string; apiEndpoint?: string; documentDetailsUrl?: string; localeCode?: string; idmsToken?: string; myDocumentsAddedLabel?: string; myDocumentsRemovedLabel?: string; myDocumentsUrl?: string; myDocumentsCta?: string; showMyDocuments?: boolean; appSource?: string; userProfile?: string; }",
          "references": {
            "Partial": {
              "location": "global"
            },
            "DDCProps": {
              "location": "import",
              "path": "../../globals/ddc"
            }
          }
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "This parameter contains configurations for the document listing component.\nFor more information, please visit\nhttps://confluence.se.com/pages/viewpage.action?pageId=128510823"
        }
      }
    };
  }
  static get states() {
    return {
      "isTabsInitialized": {},
      "isLoading": {},
      "documentsTabEnabled": {},
      "hostWithLocale": {}
    };
  }
  static get watchers() {
    return [{
        "propName": "productCtas",
        "methodName": "productCtasDidChange"
      }];
  }
}
